import type {FC, RefObject} from 'react';

import styled from 'styled-components';

import type {Nullable, WithDomStyleProp} from '../../utils/utility-types';
import type {Props, StyledProps} from './types';

import {useController} from './controller';
import {web} from './styles';

const StyledClickable = styled.div<StyledProps>`
  ${web};
`;

export const Clickable: FC<
  WithDomStyleProp<Props> & {ref?: RefObject<Nullable<HTMLDivElement>>}
> = ({children, testID, ...rest}) => {
  const {clickHandler} = useController(rest);

  return (
    <StyledClickable {...rest} data-test-id={testID} onClick={clickHandler}>
      {children}
    </StyledClickable>
  );
};
